import { axiosInstance } from "./axiosInstance";

/**
 * Fetch job offer details for a specific user and job
 * @param {string} userId - The user ID
 * @param {string} jobId - The job ID
 * @returns {Promise} - Response with job offer details
 */
export const fetchJobOfferDetails = async (userId, jobId) => {
  try {
    const response = await axiosInstance.post(
      "/job/getJobOfferDetails",
      {
        USER_ID: userId,
        JOB_ID: jobId,
      }
    );
    return response;
  } catch (error) {
    console.error("Error fetching job offer details:", error);
    throw error;
  }
};

/**
 * Save job offer response (Accept/Reject)
 * @param {string} userId - The user ID
 * @param {string} jobId - The job ID
 * @param {string} status - "OfferAccepted" or "OfferRejected"
 * @returns {Promise} - Response from API
 */
export const saveJobOfferResponse = async (userId, jobId, status) => {
  try {
    const response = await axiosInstance.post(
      "/job/saveAndRemoveJob",
      {
        USER_ID: userId,
        JOB_ID: jobId,
        STATUS: status,
      }
    );
    return response;
  } catch (error) {
    console.error("Error saving job offer response:", error);
    throw error;
  }
};

/**
 * Send job offer to clinician
 * @param {string} jobId - The job ID
 * @param {string} clinicianId - The clinician ID
 * @param {string} payRate - The pay rate
 * @returns {Promise} - Response from API
 */
export const sendOfferToClinician = async (jobId, clinicianId, payRate) => {
  try {
    const response = await axiosInstance.post(
      "/job/sendOfferToClinician",
      {
        jobId: jobId,
        clinicianId: clinicianId,
        payRate: payRate,
      }
    );
    return response;
  } catch (error) {
    console.error("Error sending offer to clinician:", error);
    throw error;
  }
};
